import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AudioDictationService } from 'src/app/shared/services/audio-dictation.service';
import { Assistant, Prompt } from 'src/app/shared/models';
import { AutomationService } from 'src/app/shared/services/automation.service';
import { FirebaseService } from 'src/app/shared/services/firebase.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PayerService } from 'src/app/shared/services/payer.service';
import { UploadLcdPolicyDocModalComponent } from '../automation/upload-lcd-policy/upload-lcd-policy-doc-modal.component';

@Component({
  selector: 'app-lcd-policy-documemt',
  templateUrl: './lcd-policy-documemt.component.html',
  styleUrls: ['./lcd-policy-documemt.component.scss'],
})
export class LcdPolicyDocumemtComponent implements OnInit {
  originalPrompt: string = '';
  isPromptChanged: boolean = false;
  assistantInfo: Assistant = null;
  // API-fetched
  lcdData: any = null;
  ortMastersApi: any[] = [];
  // User-uploaded
  policyDocFile: File | null = null;
  ortMastersFiles: File[] = [];
  assistantPractice: string;
  assistantUID: string;
  transcription: string = '';
  payer: any = [];
  prompt: string = '';
  doctorNotes: string = '';
  isLoading: boolean = false;
  parsedData: any = null;
  prompts: Prompt[] = [];
  selectedPrompt: Prompt | null = null;
  selectedPromptId: string = '';
  isPublishing: boolean = false;
  cptCode: string = '';
  selectedFile: File | null = null;
  ortMasters: File[] = [];
  payers: string[] = [
    'Health Net',
    'Humana',
    'Medicare',
    'Worksman Comp.',
    'Great West',
    'UHC',
    'Aetna',
    'Cigna',
    'Blue Cross Blue Shield',
    'Blue Shield of California',
    'Sante',
    'Anthem',
    'Physician Mutual Insurance',
    'State Farm',
    'MUTUAL OF OMAHA INSURANCE COMPANY',
    'Adventist Health',
    'Alignment Health Plan',

  ];
  selectedPayer: string = '';
  lcdFiles: any[] = [];
  selectedLcdFileId: string = '';
  infoMessages: string[] = [];
  orderDeatils:any = null;
  // UI state for ORT Masters pagination in the response section
  currentOrtPage: number = 1;
  ortPageSize: number = 1; // show one ORT per page as requested

  @ViewChild('docRef') docRef!: ElementRef;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private automationService: AutomationService,
    private payerService: PayerService,
    private spinnerService: NgxSpinnerService,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {}
  

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(params => {
      if (params['cptCode']) {
        let cpt = params['cptCode'];
        this.cptCode = cpt;
      }
      if (params['insurance']) {
        this.selectedPayer = params['insurance'];
        const payerExists = this.payers.some(
          p => p.toLowerCase() === this.selectedPayer.toLowerCase()
        );
        if (this.selectedPayer && !payerExists) {
          this.payers = [this.selectedPayer, ...this.payers];
          // console.log('Added new payer:', this.selectedPayer);
        }
      }
      if (params['orderId']) {
        (this as any).orderId = params['orderId'];
      }

      if ((this as any).orderId && this.cptCode) {
        this.getOrderByOrderId((this as any).orderId);
      }
      if (this.selectedPayer) {
        this.fetchLcdFiles();
      }
    });
    this.loadPrompts();
  }

  async getOrtMastersForPatient(patient_id : any): Promise<void> {
    try {
      this.automationService.getLastSixMonthsOrtMasters(patient_id).then((response) => {
        if (response && response.data && response.data.ortMasters) {
          this.ortMastersApi = response.data.ortMasters;
          this.ortMasters = this.ortMastersApi.slice();
          this.currentOrtPage = 1; // reset to first page when data loads
        } else {
          this.ortMastersApi = [];
          this.ortMasters = [];
          this.toastr.error('No Medical Records found for this patient in last six months.');
        }
      });
    } catch (error) {
      this.ortMastersApi = [];
      this.ortMasters = [];
      console.error('Failed to load Ort Masters:', error);
      this.toastr.error('Failed to load Medical Records');
    }
  }

  async getOrderByOrderId(order_id : any): Promise<void> {
    try {
      this.automationService.getOrderByOrderId(order_id).then((response) => {
        if (response && response.data && response.data.unique_patient) {
          this.getOrtMastersForPatient(response.data.unique_patient.uniq_id);
          this.orderDeatils = response.data;
          // console.log("orderDeatils",this.orderDeatils);
        } else {
          this.ortMastersApi = [];
          this.ortMasters = [];
          this.toastr.error('No Medical Records found for this patient in last six months.');
        }
      });
    } catch (error) {
      this.ortMastersApi = [];
      this.ortMasters = [];
      console.error('Failed to load Ort Masters:', error);
      this.toastr.error('Failed to load Medical Records');
    }
  }

  // New: Triggered when payer is changed in the UI
  onPayerChange(): void {
    if (this.selectedPayer) {
      this.fetchLcdFiles();
    }
  }

  onCptBlur(): void {
    if (this.cptCode && this.selectedPayer) {
      this.fetchLcdFiles();
    }
  }

  async fetchLcdFiles(): Promise<void> {
      this.spinnerService.show();
      const listResponse = await this.automationService.getLCDFileByPayer(this.selectedPayer);
      let specificDoc = null;
      if (this.cptCode && this.cptCode.trim()) {
          const specificResponse = await this.automationService.getLCDByCPT(this.cptCode.trim(), this.selectedPayer);
          // console.log(specificResponse);
          if (specificResponse && specificResponse.data && specificResponse.data.lcd_file) {
            specificDoc = specificResponse.data.lcd_file;
          }
      }

      this.spinnerService.hide();
      
      if (listResponse && listResponse.data) {
        const rawList = Array.isArray(listResponse.data) ? listResponse.data
          : listResponse.data.lcdDocuments || listResponse.data.lcds || listResponse.data.lcdFiles || [];
        this.lcdFiles = rawList;

        if (specificDoc) {
          const specificId = specificDoc.id || specificDoc._id || specificDoc.file_name || '';
          const matchInList = this.lcdFiles.find(f => (f.id || f._id || f.file_name) === specificId);
          if (matchInList) {
            this.selectedLcdFileId = specificId;
          } else {
            this.selectedLcdFileId = '';
          }
        } else {
          this.selectedLcdFileId = '';
        }
        
        if (this.lcdFiles.length === 0) {
          this.toastr.info('No policy documents found for this payer.');
        }
      } else {
        this.lcdFiles = [];
        this.selectedLcdFileId = '';
        this.toastr.info('No policy documents found for this payer.');
      }
  }

  // Pagination helpers for ORT Masters in document view
  get totalOrtPages(): number {
    const total = Math.ceil((this.ortMasters?.length || 0) / this.ortPageSize);
    return total > 0 ? total : 1;
  }

  prevOrtPage(): void {
    if (this.currentOrtPage > 1) this.currentOrtPage--;
  }

  nextOrtPage(): void {
    if (this.currentOrtPage < this.totalOrtPages) this.currentOrtPage++;
  }

  downloadPdfForSection(): void {
    try {
      // Helpers
      const safe = (val: any) => (val === undefined || val === null) ? '' : String(val);
      const escapeHtml = (s: string) => s.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const formatDate = (d: any): string => {
        try {
          if (!d) return '';
          const date = (typeof d === 'string' || typeof d === 'number') ? new Date(d) : d;
          if (isNaN(date as any)) return '';
          return new Date(date).toLocaleDateString();
        } catch { return ''; }
      };

      // Patient info
      const mrn = safe(this.orderDeatils?.unique_patient?.med_rec_nbr);
      const name = [safe(this.orderDeatils?.unique_patient?.first_name), safe(this.orderDeatils?.unique_patient?.last_name)].filter(Boolean).join(' ');
      const memberId = safe(this.orderDeatils?.ai_order_insurance?.member_id);
      const plan = safe(this.orderDeatils?.ai_order_insurance?.insurance_plan);
      const cpt = safe(this.cptCode);
      const payer = safe(this.selectedPayer);

      // ORT sections: each after the first starts on a new page
      const allOrts = (this.ortMasters || []);
      const ortSections = allOrts.map((ort: any, idx: number) => {
        const labelIdx = idx + 1;
        const dateVal = ort?.date || ort?.lastModified || ort?.lastModifiedDate || '';
        const displayDate = formatDate(dateVal);
        const header = `Medical Record ${labelIdx}${displayDate ? ' - ' + displayDate : ''}`;
        const notes = safe(ort?.master_notes);
        const fallback = !notes && ort?.name ? `File: ${safe(ort.name)}` : '';
        const body = notes || fallback || '';
        const pageBreakClass = idx === 0 ? '' : ' page-break';
        return `
          <div class="ort-item${pageBreakClass}">
            <div class="ort-title">${header}</div>
            ${body ? `<pre class="ort-notes">${escapeHtml(body)}</pre>` : ''}
          </div>
        `;
      }).join('');

      const aiResponse = safe(this.parsedData?.Description);

      const styles = `
        <style>
          body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 16px; color:#212529; }
          .document-container { background: #fff; border: 1px solid #e9ecef; border-radius: 8px; padding: 16px; padding-bottom: 24px; }
          .section-title { margin: 0 0 10px 0; font-size: 18px; color:#073786; }
          .patient-meta { font-size: 13px; color: #495057; display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 12px; }
          .patient-meta span { display:inline-flex; gap:6px; }
          h6 { margin: 0 0 8px 0; }
          pre { white-space: pre-wrap; word-break: break-word; background:#fafbfc; border:1px solid #e9ecef; border-radius:6px; padding:12px; }
          hr { border: none; border-top: 1px solid #e9ecef; margin: 12px 0; }
          .ort-item { border:1px solid #f1f3f5; border-radius:6px; padding:10px; background:#fafbfc; margin-bottom:10px; }
          .ort-title { font-weight: 600; font-size: 14px; color:#343a40; margin-bottom:6px; }
          .ort-notes { margin: 0; }
          .meta-inline { display:flex; gap:12px; flex-wrap:wrap; }
          /* ensure new page for every ORT (except the first) */
          .page-break { page-break-before: always; break-before: page; }
          @media print { button { display: none !important; } }
        </style>
      `;

      // Build hidden container in the same window
      const containerWrapper = document.createElement('div');
      containerWrapper.style.position = 'fixed';
      containerWrapper.style.left = '-9999px';
      containerWrapper.style.top = '0';
      containerWrapper.style.width = '800px';
      containerWrapper.style.zIndex = '-1';
      containerWrapper.innerHTML = `
        ${styles}
        <div class="document-container">
          <h5 class="section-title">Patient Info</h5>
          <div class="patient-meta">
            ${mrn ? `<span><strong>MRN:</strong> <span>${mrn}</span></span>` : ''}
            ${name ? `<span><strong>Name:</strong> <span>${name}</span></span>` : ''}
            ${memberId ? `<span><strong>Member ID:</strong> <span>${memberId}</span></span>` : ''}
            ${plan ? `<span><strong>Plan:</strong> <span>${plan}</span></span>` : ''}
            ${cpt ? `<span><strong>CPT:</strong> <span>${cpt}</span></span>` : ''}
            ${payer ? `<span><strong>Payer:</strong> <span>${payer}</span></span>` : ''}
          </div>

          <hr />

          <h6>Medical Necessity Summary</h6>
          <pre>${escapeHtml(aiResponse)}</pre>

          <div class="ort-section page-break">
            <h6>Clinicals</h6>
            ${allOrts.length ? ortSections : '<div class="text-muted">No Medical Records available.</div>'}
          </div>
        </div>
      `;
      document.body.appendChild(containerWrapper);

      const fnameParts = [name, cpt, payer].filter(Boolean);
      const filename = `${fnameParts.join('_').replace(/\s+/g, '_') || 'document'}_coverage.pdf`;

      const ensureHtml2Pdf = (): Promise<void> => {
        return new Promise((resolve, reject) => {
          if ((window as any).html2pdf) { resolve(); return; }
          const s = document.createElement('script');
          s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
          s.crossOrigin = 'anonymous';
          s.referrerPolicy = 'no-referrer';
          s.onload = () => resolve();
          s.onerror = () => reject(new Error('Failed to load html2pdf'));
          document.head.appendChild(s);
        });
      };

      (async () => {
        try {
          await ensureHtml2Pdf();
          const opt: any = {
            // [top, left, bottom, right] margins in inches
            margin: [0.5, 0.5, 0.8, 0.5],
            filename,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['css', 'legacy'] },
          };
          await (window as any).html2pdf().set(opt).from(containerWrapper.querySelector('.document-container')).save();
        } catch (err) {
          console.error('PDF generation failed', err);
          this.toastr.error('Failed to generate PDF. Please check network/popup settings.');
        } finally {
          if (containerWrapper && containerWrapper.parentNode) {
            containerWrapper.parentNode.removeChild(containerWrapper);
          }
        }
      })();
    } catch (e) {
      this.toastr.error('Failed to prepare PDF');
    }
  }

  onSelectLcdFile(): void {
    // Selection is maintained only via selectedLcdFileId now.
    // No additional state required here.
  }

  // Open the upload LCD policy modal so users can upload when not found
  openUploadModal(): void {
    this.modalService.open(UploadLcdPolicyDocModalComponent, {
      size: 'xl',
      animation: true,
      centered: true,
      backdrop: 'static',
      keyboard: false,
    }).result
      .then(() => {
        // After successful upload, refresh the list for the current payer
        if (this.selectedPayer) {
          this.fetchLcdFiles();
        }
      })
      .catch(() => {});
  }

  async loadPrompts(): Promise<void> {
    try {
      this.automationService.getLCDActivePrompt().then((response) => {
        if (response && response.data && response.data) {
          // Only set prompt if user hasn't changed it yet
          if (!this.prompt || this.prompt.trim() === '') {
            this.prompt = response.data;
            this.originalPrompt = response.data;
          }
        }
      });
    } catch (error) {
      console.error('Failed to load prompts:', error);
      this.toastr.error('Failed to load prompts');
    }
  }

  onPromptChange(newValue: string): void {
    this.isPromptChanged = newValue !== this.originalPrompt;
  }

  savePrompt(): void {
    if (!this.prompt.trim()) {
      this.toastr.error('Prompt cannot be empty.');
      return;
    }
    this.spinnerService.show();
    this.automationService.savePrompt(this.prompt)
      .then((resp: any) => {
        if (resp.code === 200) {
          this.toastr.success('Prompt saved successfully!');
          this.originalPrompt = this.prompt;
          this.isPromptChanged = false;
        } else {
          this.toastr.error('Failed to save prompt.');
        }
      })
      .catch(() => {
        this.toastr.error('Error saving prompt.');
      })
      .finally(() => {
        this.spinnerService.hide();
      });
  }


  getPayers(): void {
    this.spinnerService.show();
    this.payerService
      .getPayerByClientId(this.assistantInfo.client_id)
      .then((resp: any) => {
        this.spinnerService.hide();
        if (resp.code === 200) {
          this.payer = resp.data || [];
        } else {
          this.toastr.error('Unable to get payers data');
        }
      })
      .catch((error) => {
        this.spinnerService.hide();
        this.toastr.error('Error loading payers data');
      });
  }

  onOrtsSelected(event: any): void {
  const files: FileList = event.target.files;
  this.ortMastersFiles = Array.from(files);
  this.ortMasters = this.ortMastersFiles.slice();
  // If user uploads files, clear API-fetched ort masters data
  this.ortMastersApi = [];
  }

  removeOrtMaster(index: number): void {
    this.ortMasters.splice(index, 1);
    // Also update the correct source
    if (this.ortMastersApi.length && index < this.ortMastersApi.length && this.ortMasters[index] === this.ortMastersApi[index]) {
      this.ortMastersApi.splice(index, 1);
    }
    if (this.ortMastersFiles.length && index < this.ortMastersFiles.length && this.ortMasters[index] === this.ortMastersFiles[index]) {
      this.ortMastersFiles.splice(index, 1);
    }
  }

  onPromptDropdownChange(selectedId: string): void {
    if (selectedId) {
      const prompt = this.prompts.find((p) => p.id === +selectedId);
      if (prompt) this.onPromptSelected(prompt);
    } else {
      this.selectedPrompt = null;
      this.selectedPromptId = '';
    }
  }

  onPromptSelected(prompt: Prompt): void {
    this.prompt = prompt.content;
    this.selectedPrompt = prompt;
    this.selectedPromptId = prompt.id.toString();
  }

  generateResponse(): void {
    if (!this.cptCode.trim()) {
      this.toastr.error('Please enter CPT code');
      return;
    }
    if (!this.selectedPayer.trim()) {
      this.toastr.error('Please select a payer');
      return;
    }
    if (!this.selectedLcdFileId.trim()) {
      this.toastr.error('Please select an LCD policy document');
      return;
    }

    // Validation
    const hasPolicyDoc = !!this.selectedLcdFileId;
    const hasOrtMasters = (this.ortMastersFiles && this.ortMastersFiles.length > 0) || (this.ortMastersApi && this.ortMastersApi.length > 0);
    if (!hasPolicyDoc) {
      this.toastr.error('Please upload a PDF file for the policy document or ensure it is selected');
      return;
    }
    if (!hasOrtMasters) {
      this.toastr.error('Please upload at least one Medical Record file');
      return;
    }
    if (!this.prompt.trim()) {
      this.toastr.error('Please enter a prompt');
      return;
    }

    this.isLoading = true;
    this.parsedData = null;

    let promptToSend = this.prompt || '';
    const requiredVars = [
      { pattern: /\$\{ortMasters\}/, label: '${ortMasters}' },
      { pattern: /\$\{cptCode\}/, label: '${cptCode}' },
      { pattern: /\$\{PolicyContent\}/, label: '${PolicyContent}' },
    ];
    const missingVars = requiredVars
      .filter((v) => !v.pattern.test(promptToSend))
      .map((v) => v.label);
    if (missingVars.length > 0) {
      this.toastr.error('Prompt must include: ' + missingVars.join(', '));
      this.isLoading = false;
      return;
    }
    this.spinnerService.show();
    this.automationService
      .getLCDCoverage(
        this.cptCode,
        promptToSend,
        this.selectedLcdFileId,
        this.ortMastersFiles,
        this.ortMastersApi,
        this.selectedPayer || ''
      )
      .then((response) => {
        if (response.code === 200) {
          try {
            this.parsedData = JSON.parse(response.data);
          } catch (error) {
            this.parsedData = null;
          }
        } else if (response.code === 400) {
          this.toastr.error(
            response.message ||
              'Bad request. Please check your input and try again.'
          );
          this.isLoading = false;
        }
        this.spinnerService.hide();
      })
      .catch((error) => {
        this.toastr.error(error.message || 'Failed to generate LCD coverage');
        this.isLoading = false;
      })
      .finally(() => {
        this.spinnerService.hide();
        this.isLoading = false;
      });
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
    ];
    if (!/[0-9]/.test(event.key) && allowedKeys.indexOf(event.key) === -1) {
      event.preventDefault();
    }
  }
}
